import React from 'react';
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';

import logoTc from "../../images/logo.png"

// Font.register({ family: 'Source Serif Pro', src: 'http://fonts.gstatic.com/s/sourceserifpro/v4/CeUM4np2c42DV49nanp55aqQQDHDiKO-LH8MFmRo0b0.ttf' });

const styles = StyleSheet.create({
  page: {
    paddingTop: 60,
    paddingBottom: 40,
    paddingHorizontal: 30,
    backgroundColor: '#fff',
  },
  logo: {
    width: 212,
    height: 55,
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  content: {
    top: 12,
    flexDirection: 'row',
    // fontSize: 10,
    // marginBottom: 20,
  },
  contentGrid: {
    width: '50%',
    top: 20,
    // marginBottom: 20,
    // lineHeight: 1.5
  },
  boldText: {
    fontWeight: 'bold',
  },
  textoCabecera: {
    fontSize: 10,
    // fontWeight: 'bold',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  tableColHeader: {
    width: '16%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#eee',
    padding: 5,
  },
  tableCol: {
    width: '16%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    wordBreak: 'break-word'
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  tableCell: {
    fontSize: 9,
  },
  header: {
    position: 'absolute',
    top: 20,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  footer: {
    position: 'absolute',
    bottom: 15,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 9,
    color: 'gray',
  },
});


// PAGE SIZE: https://github.com/diegomura/react-pdf/blob/master/packages/layout/src/page/getSize.ts

const Postulantes = ({oferta, postulaciones, estados = []}) => {

    return (
        <Document>
          <Page size="A4" style={styles.page}>
            {/* ENCABEZADO */}
            <View style={styles.header}>
              {/* Logo */}
              <Image style={styles.logo} src={logoTc} />
              {/* Título */}
              <Text style={styles.headerTitle}>Listado de postulaciones</Text>
              {/* Fecha */}
              <Text style={{ fontSize: 10 }}>{new Date().toLocaleDateString()}</Text>
            </View>

            {/* Contenido */}
            <View style={styles.content}>
              <View style={{...styles.contentGrid, width: '60%'}}>
                {/* <View><Text style={styles.textoCabecera}><Text style={styles.boldText}>Oferta:</Text> {oferta.titulo}</Text></View> */}
                {/* <View><Text style={styles.textoCabecera}><Text style={styles.boldText}>Fecha del Informe:</Text> {resource.fecha_informe}</Text></View>
                <View><Text style={styles.textoCabecera}><Text style={styles.boldText}>Observaciones:</Text> {resource.observaciones}</Text></View> */}
              </View>
              <View style={{...styles.contentGrid, width: '40%'}}>
                <View><Text style={styles.textoCabecera}><Text style={styles.boldText}>Cantidad:</Text> {(postulaciones || []).length} postulaciones</Text></View>
                {/* <View><Text style={styles.textoCabecera}><Text style={styles.boldText}>Egresados:</Text> {contadorInforme.egresados}</Text></View>
                <View><Text style={styles.textoCabecera}><Text style={styles.boldText}>Saldo:</Text> {contadorInforme.ingresados - contadorInforme.egresados}</Text></View> */}
              </View>
            </View>


            {/* Tabla */}
            <View style={{ marginTop: 40 }}>
              <View style={styles.table}>
                {/* Cabecera */}
                <View style={styles.tableRow}>
                  <View style={{...styles.tableColHeader, width: '20%'}}><Text style={styles.tableCellHeader}>Concurso</Text></View>
                  <View style={{...styles.tableColHeader, width: '20%'}}><Text style={styles.tableCellHeader}>Postulante</Text></View>
                  <View style={{...styles.tableColHeader, width: '20%'}}><Text style={styles.tableCellHeader}>Email</Text></View>
                  <View style={{...styles.tableColHeader, width: '10%'}}><Text style={styles.tableCellHeader}>Estado</Text></View>
                  <View style={{...styles.tableColHeader, width: '10%'}}><Text style={styles.tableCellHeader}>Puntaje</Text></View>
                  <View style={{...styles.tableColHeader, width: '20%'}}><Text style={styles.tableCellHeader}>Fecha Postulación</Text></View>
                </View>

                {/* Filas de datos */}
                {(postulaciones || []).map((postulacion, idx) => (
                  <View style={styles.tableRow} key={idx} wrap={false}>
                    <View style={{...styles.tableCol, width: '20%'}}><Text style={styles.tableCell}>
                      <Text style={styles.boldText}>{postulacion.oferta && postulacion.oferta.titulo}</Text>
                    </Text></View>

                    <View style={{...styles.tableCol, width: '20%'}}><Text style={styles.tableCell}>
                      <Text style={styles.boldText}>{postulacion.usuario && postulacion.usuario.apellido}</Text> {postulacion.usuario && postulacion.usuario.nombre}
                    </Text></View>

                    <View style={{...styles.tableCol, width: '20%'}}><Text style={styles.tableCell}>
                      {postulacion.usuario && postulacion.usuario.email}
                    </Text></View>

                    <View style={{...styles.tableCol, width: '10%'}}><Text style={styles.tableCell}>
                      {postulacion.estado}
                    </Text></View>

                    <View style={{...styles.tableCol, width: '10%'}}><Text style={styles.tableCell}>
                      {postulacion.puntaje}
                    </Text></View>

                    <View style={{...styles.tableCol, width: '20%'}}><Text style={styles.tableCell}>
                      <Text style={styles.boldText}>{postulacion.fecha_postulacion}</Text>{"\n"}
                      <Text >({postulacion.dias_desde_fecha_postulacion} días atrás)</Text>
                    </Text></View>
                  </View>
                ))}
              </View>
            </View>



            {/* PIE DE PÁGINA */}
            {/* <Text style={styles.footer} render={({ pageNumber, totalPages }) =>
              `Página ${pageNumber} de ${totalPages}`
            } /> */}
            {/* Pie de página */}
            <Text style={styles.footer}>
                {new Date().toLocaleDateString()} - Documento confidencial
            </Text>
          </Page>
        </Document>
    );
};

export default Postulantes;